var NahmSpirit = NahmSpirit || {};

NahmSpirit.ReservationPicker = function () {

	var _settings = {
		pickers : '.location-picker',
		widgets : '.booking-widget'
	};

	var _init = function (options) {
		$(_settings.pickers).on('click', function() {
			let picker = $(this);
			let location = picker.data('location');
			// deactivate other pickers
			$(_settings.pickers + '.active')
				.removeClass('active')
				.removeAttr('aria-pressed');
			// update clicked picker to active
			picker
				.addClass('active')
				.attr('aria-pressed', 'true');
			// show correct booking widget
			$(_settings.widgets).each(function() {
				let widget = $(this);
				if (widget.data('loc-scope') === location) {
					widget.slideDown();
				} else {
					widget.slideUp();
				}
			})
		});
	}

	/** PUBLIC API **/
	return {
		init: function (options) { return _init(options); }
	};

}();

$(function () {
  NahmSpirit.ReservationPicker.init();
});
